import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CCheckboxComponent } from './c-checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CCheckboxComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsPipesModule,
  ],
  exports: [CCheckboxComponent]
})
export class CCheckboxModule { }
